import React from 'react';
import { COMPANY_INFO } from '../data/scrapedData';

export function FloatingCTA() {
  return (
    <div 
      aria-label="Hurtige genveje til kontakt"
      className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-3"
    >
      {/* Phone Floating CTA */}
      <a
        href={COMPANY_INFO.phoneTel}
        className="w-12 h-12 sm:w-13 sm:h-13 rounded-full bg-[#3885B8] text-white shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 ease-in-out hover:scale-110 focus:scale-110 active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#3885B8] group"
        title={`Ring til os på ${COMPANY_INFO.phone}`}
        aria-label={`Ring til os på ${COMPANY_INFO.phone}`}
      >
        <i className="fa-solid fa-phone text-lg transition-transform duration-300 group-hover:rotate-12" aria-hidden="true" />
      </a>

      {/* Email Floating CTA */}
      <a
        href={COMPANY_INFO.emailMailto}
        className="w-12 h-12 sm:w-13 sm:h-13 rounded-full bg-[#1C1C1E] text-white shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 ease-in-out hover:scale-110 focus:scale-110 active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#1C1C1E] group"
        title={`Send mail til ${COMPANY_INFO.email}`}
        aria-label={`Send mail til ${COMPANY_INFO.email}`}
      >
        <i className="fa-solid fa-envelope text-lg transition-transform duration-300 group-hover:-translate-y-0.5" aria-hidden="true" />
      </a>
    </div>
  );
}
